import React from 'react';

const FinalCTA = ({ t }) => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 64;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section data-testid="final-cta-section" className="relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="/images/renders/He_001b.jpg"
          alt="Hexaparks entrance gateway"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/60" />
      </div>

      {/* Content */}
      <div className="relative py-16 sm:py-20 lg:py-28">
        <div className="container mx-auto px-5 sm:px-6 lg:px-8 max-w-3xl text-center">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-light text-white mb-4 leading-snug">
            {t.finalCta.title}
          </h2>
          <p className="text-sm text-white/70 mb-8 max-w-lg mx-auto">
            {t.finalCta.subtitle}
          </p>
          <button
            data-testid="final-cta-button"
            onClick={scrollToContact}
            className="px-8 py-3 bg-white text-gray-900 text-xs uppercase tracking-[0.12em] hover:bg-gray-100 transition-colors font-medium"
          >
            {t.finalCta.button}
          </button>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
